<template>
  <v-card color="white" class="section-bg rounded" elevation="0">
    <!-- <v-card-title primary-title style="padding: 0px"> -->
    <!-- <v-card style="position: absolute">
        <v-card-text>
          <v-icon
            :color="config.floatTextColor"
            :dark="config.floatIconDark || config.floatIconDark === undefined"
            :size="config.floatIconSize || 40"
            >{{ config.floatIcon }}</v-icon
          >
        </v-card-text>
      </v-card> -->
    <v-card-text>
      <div class="text-xs-center">
        <!-- <div class="grey--text font-weight-medium">
            {{ config.balanceName }}
          </div> -->
        <div class="d-inline-flex align-center">
          <img
            alt="Ovation"
            width="32"
            src="https://s3.us-east-2.amazonaws.com/s3-img.giveovation.com/Ovation-260-260.png"
            style="width: 32px"
          />
          <div :class="config.textClass + ' ml-2'">
            {{
              Number(config.balanceAmount) > 0
                ? Number(config.balanceAmount).toLocaleString()
                : 0
            }}
          </div>
        </div>
        <!-- <div :class="config.textClass">
          <img
            style="vertical-align: middle"
            class="mr-1"
            src="https://s3.us-east-2.amazonaws.com/s3-img.giveovation.com/favicon-32x32.png"
            alt="Ovation"
          />
          <span>
            {{
              Number(config.balanceAmount) > 0
                ? Number(config.balanceAmount).toLocaleString()
                : 0
            }}</span
          >
        </div> -->
      </div>
    </v-card-text>

    <v-card-actions class="no-padding" v-if="config.balanceAmount > 0">
      <v-btn
        class="btn-rounded-medium"
        v-if="config.inAppLink"
        block
        dark
        :color="config.btnColor"
        :to="config.actionLink"
      >
        <!-- <v-icon
          :dark="config.actionIconDark"
          :size="config.actionIconSize || 20"
          class="mr-2"
          >{{ config.actionIcon }}</v-icon
        > -->
        {{ config.actionText }}
      </v-btn>
      <v-btn
        class="btn-rounded-medium"
        v-if="!config.inAppLink"
        block
        dark
        :color="config.btnColor"
        :href="config.actionLink"
        :target="config.target"
        :class="{
          caption:
            $vuetify.breakpoint.xs ||
            $vuetify.breakpoint.sm ||
            $vuetify.breakpoint.md,
        }"
      >
        <!-- <v-icon
          :dark="config.actionIconDark"
          :size="config.actionIconSize || 20"
          class="mr-2"
          :class="{ 'hidden-xs-only': true }"
          >{{ config.actionIcon }}</v-icon
        > -->
        {{ config.actionText }}
      </v-btn>
      <v-btn
        class="btn-rounded-medium"
        v-if="!config.inAppLink && config.shareSpendOvations"
        block
        dark
        :color="config.btnColor"
        :to="config.shareLink"
        :class="{
          caption:
            $vuetify.breakpoint.xs ||
            $vuetify.breakpoint.sm ||
            $vuetify.breakpoint.md,
        }"
      >
        <!-- <v-icon
          :dark="config.actionIconDark"
          :size="config.actionIconSize || 20"
          class="mr-2"
          :class="{ 'hidden-xs-only': true }"
          >{{ config.shareIcon }}</v-icon
        > -->
        {{ config.shareText }}
      </v-btn>
    </v-card-actions>
    <v-card-actions v-else>
      <!-- <v-icon class="mr-2" color="red">mdi-alert-outline</v-icon> -->
      <div style="text-align: center; margin: auto">
        <router-link class="red-text" :to="config.actionZeroBalanceLink">{{
          config.actionTextZeroBalance
        }}</router-link>
      </div>
    </v-card-actions>
    <!-- </v-card-title> -->
  </v-card>
</template>

<script>
export default {
  name: "BalanceBlock",
  props: ["config", "bgcolorx"],
};
</script>
